module.exports = __webpack_public_path__ + "img/01.82f8676d.png";